import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { stripeApi } from '../apis/stripe.api';
// Remove Redux dispatch if action doesn't exist
// import { useDispatch } from 'react-redux';
// import { setSubscriptionStatus } from '../redux/slices/subscriptionSlice';

const SubscriptionSuccess = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState('');
  const [region, setRegion] = useState('');
  const navigate = useNavigate();
  // const dispatch = useDispatch();

  const getRegionBasedUrl = (region) => {
    console.log('**** Region:', region);
    switch (region?.toLowerCase()) {
      case 'us':
        return process.env.REACT_APP_ONBOARDING_URL_US;
      case 'eu':
        return process.env.REACT_APP_ONBOARDING_URL_EU;
      case 'apac':
        return process.env.REACT_APP_ONBOARDING_URL_APAC;
      case 'sg':
        return process.env.REACT_APP_ONBOARDING_URL_APAC; 
      case 'ap':
        return process.env.REACT_APP_ONBOARDING_URL_APAC; 
      default:
        return process.env.REACT_APP_ONBOARDING_URL_US; // Default to US if region is unknown
    }
  };

  const getRegionName = (region) => {
    switch (region?.toLowerCase()) {
      case 'us':
        return 'United States';
      case 'eu':
        return 'Europe';
      case 'apac':
        return 'Asia Pacific';
      case 'sg':
        return 'Asia Pacific';
      case 'ap':
        return 'Asia Pacific';
      default:
        return 'United States';
    }
  };

  useEffect(() => {
    const handleSubscription = async () => {
      const searchParams = new URLSearchParams(window.location.search);
      const sessionId = searchParams.get('session_id');
      console.log('**** searchParams:', searchParams);
      if (!sessionId) {
        console.error('No session ID found in URL');
        setError('Invalid session');
        setLoading(false);
        return;
      }

      try {
        const response = await stripeApi.handleSubscriptionSuccess(sessionId);
        console.log('**** Subscription success response:', response);
        
        const region = response.metadata?.region || process.env.REACT_APP_REGION_CODE.toLowerCase();
        const redirectUrl = getRegionBasedUrl(region);
        console.log('**** redirectUrl:', redirectUrl);
        setRedirectUrl(redirectUrl);
        setRegion(region);
        setLoading(false);
        setShowPopup(true);

        // Set timeout for redirect after showing popup
        setTimeout(() => {
          window.location.href = redirectUrl;
        }, 10000); // 10 seconds delay
      } catch (error) {
        console.error('Subscription processing failed:', error);
        setError(error.message || 'Failed to process subscription');
        setLoading(false);
      }
    };

    handleSubscription();
  }, []);

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
        <div className="w-full max-w-md p-8 space-y-4 bg-white rounded-lg shadow">
          <h2 className="text-2xl font-bold text-center text-gray-800">
            Processing Your Subscription
          </h2>
          <div className="flex justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
          </div>
          <p className="text-center text-gray-600">
            Please wait while we confirm your subscription...
          </p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
        <div className="w-full max-w-md p-8 space-y-4 bg-white rounded-lg shadow">
          <h2 className="text-2xl font-bold text-center text-red-600">
            Subscription Error
          </h2>
          <p className="text-center text-gray-600">{error}</p>
          <button
            onClick={() => navigate('/register')}
            className="w-full px-4 py-2 text-white bg-primary rounded hover:bg-primary-dark transition-colors"
          >
            Return to Home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
      <div className="w-full max-w-md p-8 space-y-4 bg-white rounded-lg shadow">
        <h2 className="text-2xl font-bold text-center text-green-600">
          Subscription Successful!
        </h2>
        <p className="text-center text-gray-600">
          Thank you for subscribing.
        </p>
        
        {showPopup && (
          <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
            <p className="text-blue-800 font-medium mb-2">
              Important: Next Steps
            </p>
            <p className="text-blue-700 mb-4">
              You will be redirected to the {getRegionName(region)} registration page in a few seconds.
            </p>
            <p className="text-blue-700 mb-2">
              Please complete your registration to access your subscription.
            </p>
            <div className="flex justify-center mt-4">
              <button
                onClick={() => window.location.href = redirectUrl}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
              >
                Register Now
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SubscriptionSuccess;